<template>
  <div class="phrase-logo-ctn">
    <div class="a-symbol">
      <img id="logo" src="@/assets/images/onesti-logo/a-symbol-white.svg" alt="Onesti">
    </div>
    <div id="divider" class="divider" />
    <div v-if="currentLocale !== 'cn'" class="phrase">
      <div
        class="word-ctn"
        :class="currentLocale === 'en' ? 'word-ctn--expanded-english-first' : 'word-ctn--expanded'"
      >
        <p ref="word" class="amamos" :class="{'capitalize' : currentLocale !== 'en'}">
          {{ currentLocale === 'en' ? 'We ' + $t('slogan.love') : $t('slogan.love') }}
        </p>
        <p class="after-word after-word--right-aligned fazemos-after" :class="{'capitalize' : currentLocale !== 'en'}">
          {{ currentLocale === 'en' ? 'We ' + $t('slogan.do') : $t('slogan.do') }}
        </p>
      </div>
      <div class="word-ctn">
        <p>{{ $t('slogan.what') }}</p>
      </div>
      <div class="word-ctn">
        <p>{{ $t('slogan.we') }}</p>
      </div>
      <div class="word-ctn" :class="currentLocale === 'en' ? 'word-ctn--expanded-english' : 'word-ctn--expanded'">
        <p class="fazemos">
          {{ $t('slogan.do') }}
        </p>
        <p class="after-word after-word--left-aligned amamos-after">
          {{ $t('slogan.love') }}
        </p>
      </div>
    </div>
    <div v-else class="phrase">
      <div class="word-ctn">
        <p>
          {{ $t('slogan') }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { TimelineLite, TimelineMax, Power3, Power1 } from 'gsap'
export default {
  name: 'LogoAnimPhrase',
  data () {
    return {
      areAfterWordsPurged: false
    }
  },
  computed: {
    currentLocale () {
      return this.$i18n.locale
    }
  },
  mounted () {
    const translateDistance = this.$refs['word'].getBoundingClientRect().height

    let mainTl = new TimelineLite({ paused: true })

    let presentingTl = new TimelineLite()
    presentingTl.from('#logo', 0.6, { opacity: 0, y: '-50px' }, 'logo')
      .from('#divider', 1, { scaleX: 0, ease: Power3.easeOut }, 'logo+=0.3')
      .staggerFrom('.word-ctn p:not(.after-word)', 0.6, { y: '-80px' }, 0.1, 'logo+=0.4')

    let wordsTl = new TimelineMax({ repeat: -1, yoyo: true, repeatDelay: 3 })
    wordsTl.to('.amamos', 0.6, { y: `-${translateDistance}px`, delay: 1, ease: Power1.easeInOut }, 'amamos')
      .to('.fazemos', 0.6, { y: `-${translateDistance}px`, delay: 1.2, ease: Power1.easeInOut }, 'amamos')
      .to('.fazemos-after', 0.6, { y: `-${translateDistance}px`, delay: 1.1, ease: Power1.easeInOut }, 'amamos')
      .to('.amamos-after', 0.6, { y: `-${translateDistance}px`, delay: 1.3, ease: Power1.easeInOut }, 'amamos')

    mainTl.add(presentingTl).add(wordsTl)
    mainTl.play()

    window.addEventListener('resize', () => {
      if (!this.areAfterWordsPurged) {
        wordsTl.kill()
        const movingWords = document.querySelectorAll('.word-ctn--expanded > p, .word-ctn--expanded-english > p')
        for (let word of movingWords) {
          if (word.hasAttribute('style')) word.removeAttribute('style')
        }
        this.areAfterWordsPurged = true
      }
    })
  }
}
</script>
<style scoped lang="sass">
@tailwind utilities

.phrase-logo-ctn
  @apply flex flex-col justify-center items-center

.a-symbol
  img
    height: 5rem

.divider
  width: 80%
  height: 1px
  background: #fff
  margin-top: 2rem
  @screen xl
    @apply w-256
  @screen xxl
    @apply w-256

.phrase
  @apply flex flex-wrap justify-center mt-2
  @screen sm-l
    max-height: 210px

.word-ctn
  @apply relative inline-flex justify-end text-center font-thin text-4xl overflow-hidden
  height: 50px
  @screen md
    @apply text-5xl
    height: 60px
  &:not(:first-child)
    margin-left: 1rem
  &:last-child
    @apply justify-start
  p
    @apply text-white m-0 h-full
  &--expanded
    width: 150px
    @screen md
      width: 200px
    /*@media only screen and (max-width: 750px) and (orientation: landscape)*/
    /*  width: 170px*/
  &--expanded-english
    width: 60px
    @screen md
      width: 120px
  &--expanded-english-first
    @apply whitespace-no-wrap
    width: 125px
    @screen md
      width: 170px

.after-word
  @apply absolute
  top: 100%
  &--right-aligned
    @apply pin-r
  &--left-aligned
    @apply pin-l

</style>
